<template>
  <div>
    
    <div v-if="anuncios.length == 0" class="py-5 text-center">
      <div>Nenhum anúncio encontrado.<br/>Tente buscar com outros filtros.</div>
    </div>

    <div class="row small-gutters">
      <div
        v-for="(anuncio,index) in anuncios"
        :key="'anuncio'+index"
        class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3 mb-3"
      >
        <BlocoAnuncio :dados="anuncio"></BlocoAnuncio>
      </div>
    </div>
    <!-- <div class="d-flex justify-content-center my-5"> -->
      <!-- <b-pagination
        v-model="paginaAtual"
        :limit="7"
        :total-rows="qtdTotalAnuncios"
        :per-page="qtdAnunciosPorPagina"
        prev-text="Anterior"
        next-text="Próximo"
        prev-class="pr-5"
        next-class="pl-5"
        :hide-goto-end-buttons="true"
      ></b-pagination> -->
    <!-- </div> -->

    <div class="d-flex justify-content-center my-5" v-if="qtdTotal > 0">
            <b-pagination
              :value="paginaAtual"
              :limit="7"
              :total-rows="qtdTotal"
              :per-page="qtdPorPagina"
              prev-text="Anterior"
              next-text="Próximo"
              prev-class="pr-5"
              next-class="pl-5"
              :hide-goto-end-buttons="true"
              @change="onChangePagina"
            ></b-pagination>
          </div>
  </div>
</template>

<script>
import BlocoAnuncio from "../components/BlocoAnuncio";

export default {
  props:['dados','paginaAtual','qtdTotal','qtdPorPagina'],
  components: {
    BlocoAnuncio
  },
  data() {
    return {
     
    };
  },
  computed:{
    anuncios(){
      return this.dados?.itens || [];
    }
  },
  methods:{
    onChangePagina(pagina){
      this.$emit('change-pagina',pagina);
    }
  }
};
</script>


<style lang="less" >
@import "../styles/variaveis";

.page-link {
  background: none;
  border: none;
  color: @default-text-color;
  border-radius: 4px;
  padding: 0.3rem 0.4rem;
}

.page-link:hover {
  color: @primary-color !important;
}

.page-item.active .page-link {
  background-color: @primary-color;
  border-color: @primary-color;
}

.page-item.active .page-link:hover {
  color: white !important;
}

.page-item.disabled .page-link {
  background-color: transparent;
  opacity: 0.61;
}
</style>